/* eslint-disable max-len */

export default {
  lang: 'German',
  homeScreen: {
    title: '',
    stayConnected: 'Bleibt Verbunden!',
    comingSoon: 'demnächst verfügbar (depends on context)',
    messages: 'Nachrichten/Mitteilung',
  },
  notification: {
    newAndNow: 'Neu & Jetzt!',
    alert: 'Alarm',
    message: 'Nachricht',
    contest: 'Wettbewerb',
    badge: 'Neues Abzeichen',
    'content-update': 'Inhaltsaktualisierung',
    events: 'Veranstaltungen',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Mal sehen, ob wir ein bestehendes Profil von dir in unserem System finden können.',
      homeTitleSub:
        'Gib die Emailadresse ein, die du normalerweise für die Anmeldung bei Schulungsprogrammen verwendest.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuche es mit einer anderen E-Mail oder erstelle jetzt ein Konto.',
      continueButton: 'fortsetzen',
      success:
        'Du hast dein Konto erfolgreich aktualisiert! du wirst in Kürze auf die Startseite weitergeleitet.',
      successNewAccount:
        'Um deine Anmeldung abzuschließen, erhältst du eine Bestätigungs-E-Mail, um dein Konto zu verifizieren.',
      loginButton: 'Einloggen',
      matchFound:
        'Wir haben eine Übereinstimmung gefunden. Bitte gebe dein Passwort ein, um fortzufahren.',
      magicLink: 'Melde dich über einen Link in deiner Email an.',
      magicLinkButton: 'Link anfordern',
      magicLinkTitle:
        'Lass dir einen direkten Link an deine E-Mail schicken, mit dem du dich sofort anmelden kannst.',
      otherEmailButton: 'einreichen',
      title:
        'Bitte nimm dir einen Moment Zeit, um alle nachfolgenden Angaben zu vervollständigen, da dies die Grundlage für dein Profil und deine Kontaktinformationen ist.',
      titleIndustry:
        'Bitte nimm dir einen Moment Zeit, um alle nachfolgenden Angaben zu vervollständigen, da dies die Grundlage für dein Profil und deine Kontaktinformationen ist.',
      register: 'ein Konto erstellen',
      agent: 'ReiseberaterIn',
      visitor: 'FachbesucherIn',
      step1: 'Schritt 1: Benutzertyp',
      step2: 'Schritt 2: Ein Konto erstellen',
      step3: 'Schritt 3: Erstelle dein Profil',
      marketingOptIn:
        'Bist du sicher, dass du nicht daran interessiert bist, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Kein Interesse',
      step2Sub1: 'Erzähl uns etwas über dich',
      step2Sub2: 'Erzähl uns von deinem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Kreuze die unten stehenden Kästchen an, um sicherzustellen, dass du wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Rewards, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhältst.',
      privacy:
        'Wir schützen deine Privatsphäre und verkaufen oder missbrauchen dein Vertrauen nicht.',
      store:
        'Du kannst dieses programm ganz einfach in deinem App Store herunterladen. ',
      powered: 'Unterstützt durch',
      toastMessage: {
        forgotSuccess:
          'Wir haben dir den Link zum Zurücksetzen deines Passworts per E-Mail geschickt! du wirst in 10 Sekunden zur Login-Seite weitergeleitet.',
        emailNotExisting:
          'Die von dir eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warte, wir melden dich gerade an.',
        magicLinkError:
          'Wir konnten dein Konto nicht in unserer Datenbank finden. Bitte melde dich manuell an. du wirst in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten keinen gültigen Token finden, bitte melde dich an oder fordere einen neuen Link an. Wenn dieses Problem weiterhin besteht, kontaktiere uns bitte unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten dein Konto nicht in unserer Datenbank finden. Bitte melde dich manuell an. du wirst in 10 Sekunden weitergeleitet.',
        magicLinkSuccess:
          'Schau in deiner Email {email} nach. Sie enthält einen Link, mit dem du dich anmelden kannst.',
        magicLinkErrorWait: 'Bitte warte 5 Minuten zwischen den Linkanfragen. ',
        emailNotFoundError:
          'Die von dir eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfe auf Schreibfehler oder erstelle ein Konto.',
      },
      errors: {
        zipCodeNotFound:
          'Postleitzahl nicht gefunden, bitte versuche es erneut',
        zipCodeOnlyNumbers: 'Postleitzahl kann nur Zahlen enthalten',
        password: 'Bitte gib ein Passwort ein',
        passwordNotMatching:
          'Die von dir eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        emailExists:
          'Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuche es mit einer anderen E-Mail-Adresse oder melde dich bei deinem Konto an.',
        fillInAllFields: 'Bitte fülle alle erforderlichen Felder aus',
        fillInEmail: 'Bitte gib deine E-Mail-Adresse an.',
        emailNotExisting:
          'Die von dir eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy:
          'du hast dein Passwort vergessen und möchtest es ändern?',
        forgotSubCopy2:
          'Möchtest du das Passwort ganz umgehen? Wir schicken dir eine E-Mail mit einem Link, der dich automatisch beim Programm anmeldet.',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Deine Position',
        description:
          'Was beschreibt das Geschäft deines Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Passwort bestätigen',
        firstName: 'Vorname',
        lastName: 'Nachname',
        agency: 'Name deiner Agentur',
        title: 'Deine Position (Wähle eine aus)',
        company: 'Name des Unternehmens',
        select: 'Wähle unten eine Option aus',
        state: 'Staat',
        province: 'Bundesland/Region/Staat',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe gehört dein Unternehmen in erster Linie an?',
        hostAgency: 'Deine Hostagentur',
        executive: 'GeschäftsführerIn',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales/Vertrieb',
        coordinator: 'Coordinator',
        other: 'Andere',
        opt: 'Bleibe mit dem Team dieses Programms in Verbindung und erhalte aktuelle Informationen.',
        optMarketing:
          'Bleibe mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Unabhängige(r) UnternehmerIn',
        host: 'Host Agency',
        call: 'Call Center oder Web-basierte Agentur',
        describes:
          'Was beschreibt dich und die Tätigkeit deiner Agentur am besten?',
      },
    },
    title: 'Schulung für Reisefachleute und Programm zur Verkaufsförderung',
    welcome: {
      headerTop: 'Willkommen in',
      headerBottom: 'Tampa Bay',
    },
    sellingPoints: {
      0: 'Unterwegs lernen, promoten und verkaufen',
      1: 'Multimediales Training über verschiedene Geräte hinweg',
      2: 'Abschlusszertifikat',
      3: 'Fertige Verkaufspräsentationen',
      4: 'Hochwirksame Werbematerialien',
      5: 'Insider-Tipps und Promotions',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Nachrichten und Updates',
    },
    emailPrompt:
      'Bitte gebe deine E-Mail-Adresse und dein Passwort ein, um zu bestätigen, dass du ein Vertreter der Reisebranche bist.',
    tAndC: {
      agree: 'Wenn du fortfährst, stimmst du unseren ',
      privacyPolicy: 'Datenschutzbestimmungen',
      and: ' und ',
      termsConditions: 'allgemeine Geschäftsbedingungen zu.',
    },
    fields: {
      what: 'Welche Art von Reisen verkaufst du?',
      what1: 'Was ist die Nummer 1 unter den von dir verkauften Reisen?',
      what2: 'Was ist die Nummer 2 unter den von dir verkauften Reisen?',
      what3: 'Was ist die Nummer 3 unter den von dir verkauften Reisen?',
      agency: 'Agentur',
      email: 'Email',
      password: 'Passwort',
      passwordConfirm: 'Bestätige dein Passwort',
      firstName: 'Vorname',
      lastName: 'Nachname',
      agencyName: 'Name der Agentur',
      city: 'Stadt',
      stateProvince: 'Staat/Provinz *',
      salutation: 'Anrede *',
      required: 'Erforderlich',
      invalidEmail: 'ungültige Email Adresse',
      opt: 'Bleibe in Kontakt! Ja, ich möchte von Visit Tampa Bay über Neuigkeiten, Veranstaltungen, incentives, FAMs und vieles mehr informiert werden!',
      complete: 'Schritt 2: Vervollständige dein Profil',
      tell: 'Erzähl uns von dir',
      title: 'Geschäftlicher Titel *',
      host: 'Name der Host Agency',
      country: 'Land / Region',
      select: 'Bitte wähle unten eine Option',
      header2: 'Welche(s) Segment(e) verkaufst du hauptsächlich?',
      step2: 'Beschreibe dein Unternehmen',
      leisure: 'Freizeit',
      corporate: 'Unternehmen',
      group: 'Gruppe',
      affiliate: 'Was ist deine wichtigste Zugehörigkeit?',
      forgot:
        'Hast du dein Passwort vergessen? Klicke auf die Schaltfläche unten und wir senden dir eine E-Mail, um dein Passwort zurückzusetzen.',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein(e) BeraterIn',
      title: 'Vielen Dank für dein Interesse an Tampa Bay.',
      messageWeb:
        'Der Inhalt dieser Website ist ausschließlich für Reisefachleute bestimmt. \nUm mehr über Tampa Bay zu erfahren, besuche bitte diese Seite: ',
      messageMobile:
        'Einige Inhalte dieser App sind ausschließlich für Reisefachleute bestimmt, aber du kannst dir gerne einen Überblick über das Angebot dieser App verschaffen, indem du auf "Weiter" klickst.',
      continue: 'Weiter',
      visitWebsite: 'Zur Website',
    },
    newUser: 'Neue(r) NutzerIn',
    register: 'Registrieren',
    registered: 'Diese E-Mail ist bereits registriert',
    forgot: ' Passwort zurücksetzen',
    header:
      'Bitte nimm dir einen Moment Zeit, um alle nachfolgenden Angaben zu vervollständigen, da dies die Grundlage für dein Profil und deine Kontaktinformationen ist.',
    step1: 'Schritt 1: Gib deine E-Mail-Adresse an und wähle ein Passwort.',
  },
  welcomeScreen: {
    title: 'Willkommen in Tampa Bay',
    helloUser: 'Hallo {{name}}',
    hello: 'Hallo,',
    fromAgency: 'von {{Agentur}}',
    notUser: 'Nicht {{Name}}?',
    introOnline:
      'Trainiere sofort online oder lade die Inhalte vor, so dass sie immer für die Offline-Nutzung verfügbar sind!',
    introOffline:
      'Du hast bereits die neueste Version vorinstalliert. Beginne jederzeit und überall mit dem Training oder dem Verkauf!',
    startTraining: 'Mit dem Lernen beginnen',
    continueTraining: 'Weiter lernen',
    graduated: 'Herzlichen Glückwunsch!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initialisierung...',
      lastUpdate: 'Letzte Aktualisierung:',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Weiter',
    review: 'Überprüfen',
    restart: 'Überprüfen',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number}% abgeschlossen',
    unlock:
      'Schalte dieses Kapitel frei, indem du das Trainingskapitel {number} abschließt.',
    unlockSubtitle:
      'Schalte weitere Kapitel frei, indem du die Trainingskapitel abschließt.',
    unlockSpecialization:
      'Schalte dieses Kapitel frei, indem du Die Grundlage abschließt.',
    allUnlocked: 'Du hast alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Weiter',
    endReached: 'Du hast das Ende erreicht',
    retainEnd:
      'Verwende die obere Leiste, um in diesem Kapitel zu navigieren, oder drücke die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Mehr sehen, hören & lesen',
    trouble:
      'Es sieht so aus, als hättest du Schwierigkeiten. Bitte lies den Inhalt der vorherigen Seite(n) noch einmal und versuche es erneut.',
    confirm: 'Antwort bestätigen',
    choose: 'Bitte wähle eine Antwort',
    skip: 'Zurück',
    viewAllTitle: 'Trainingstipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, klicke bitte auf die Symbole, um die zusätzlichen Inhalte anzuzeigen. Videos, Karten und andere hilfreiche Informationen wurden bereitgestellt, um dein Training zu verbessern und sicherzustellen, dass du den PRO-Status erreichst.',
    fillBlanks: 'Fülle die Lücke(n) aus:',
    next: 'Nächste Frage',
    retry: 'Erneut versuchen',
    fastTrackText: {
      success:
        'Herzlichen Glückwunsch, du hast den Fast-Track-Kurs bestanden und den Rest des Kurses freigeschaltet!',
      failed:
        'Leider hast du den Fast-Track-Kurs nicht bestanden. Du kannst dein Training fortsetzen, um dein Zertifikat zu erwerben!',
    },
    fastTrack: 'Werde ein Reise-Superstar!',
    fastTrackExplanation:
      'Nimm einfach an dem Quiz auf den folgenden Seiten teil und gewinne einen FAM in die Schweiz! <br><br><span style="font-weight: bold"> Alle Antworten auf die Quizfragen findest du auf folgende Weise::</span><br><br>1.\tDie Inhalte, die du in den Modulen Rail Europe und Schweiz gelernt hast.<br><br>2.\tUnd auf den folgenden Websites: <br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Lies du am Quiz teilnimmst! Nur die Teilnehmer mit der höchsten Punktzahl haben die Chance, zum FAM eingeladen zu werden. </span>',
    fastTrackButton: 'Hier klicken, um das Quiz zu beantworten',
    grading: 'Deine Endnote ist: {Note}%',
  },
  nav: {
    home: 'Home',
    train: 'trainieren',
    learn: 'lernen',
    retain: 'Beibehalten',
    directory: 'Verzeichnis',
    showRoom: 'showcases',
    showcases: 'showcases',
    offers: 'Angebote',
    promote: 'promote',
    sell: 'verkaufen',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Lerne das Team kennen',
    reportCard: 'Diplom ansehen',
    accountSettings: 'Kontoeinstellungen',
    messages: 'Nachrichten',
    search: 'Suche',
  },
  contentHeaders: {
    train: 'trainieren',
    retain: 'Beibehalten',
    subapps: 'Tampa Bay Partner-Module',
    maintrainings: 'Die Grundlage',
    subtrainings: 'Spezialisierungen',
  },
  pageDescriptions: {
    train: 'Informiere und engagiere dich. Werde zum Experten.',
    showroom: '',
    retain:
      'Herzlichen Glückwunsch zum Abschluss deines Trainings! Du hast jetzt deine wichtigste Ressource freigeschaltet, um dein Fachwissen zu bewahren und deine Verkaufstätigkeiten zu unterstützen. Nutze diesen Bereich, um eine Produktfrage fachkundig zu beantworten oder sogar eine improvisierte Verkaufspräsentation zu halten - jederzeit, überall und von jedem Gerät aus.',
    promote:
      'Teile diese Artikel, um das Interesse zu wecken und ein Gespräch mit Kunden und Interessenten zu beginnen.',
    sell: 'Beantworte Kundenfragen und schließe den Verkauf wie ein Profi ab - mit umfassenden Ressourcen und gezielter Vertriebsunterstützung.',
    favorites: 'Schau dir deine persönlich bevorzugten Inhalte an',
    search: 'Alle Inhalte durchsehen',
    subapps: '',
    maintrainings:
      'Schließe diese wichtigen Module ab, um dein Zertifikat zu erhalten.',
    subtrainings:
      'Erweitern Sie Ihr Fachwissen und verdienen Sie sich ein Abzeichen für jedes der folgenden Spezialisierungsmodule.',
  },
  general: {
    next: 'weiter',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Zurück',
    submit: 'Einreichen',
    back: 'Zurück',
    close: 'Schließen',
    page: 'Seite',
    search: 'Suche',
    logIn: 'Log in ',
    logOut: 'Log out',
    viewItem: 'Ansicht {Typ}',
    imageNotFound: 'Abbildung nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {{Abfrage}}',
    noFavorites: 'Du hast noch keine Favoriten.',
    noMessages: 'Du hast noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für: {{Abfrage}}',
    showAll: 'Alle anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Bereits vorhanden',
    pageNotFound: '404 Seite nicht gefunden!',
    oops: 'Oh oh...',
    overview: 'Zurück zur Übersicht',
    complete: 'Weiter',
    courseComplete: 'Kapitel abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: 'Nachricht {count}',
    messagePlural: 'Nachrichten {count}',
    comingSoon: 'Bald verfügbar',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Webseite',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehe die Wählscheiben, um die Antwort zu finden',
    fitb: 'Fülle das/die Feld(er) aus',
    flip: 'Ändere die Zahl entsprechend der Antwort',
    multipleChoice: 'Wähle die richtige(n) Antwort(en)',
    slider: 'Wähle die richtige Antwort mit dem Schieberegler',
    map: 'Beantworte die Frage, indem du auf den richtigen Punkt auf der Karte tippst.',
    dropdown: 'Wähle…',
    true: 'Wahr',
    false: 'Falsch',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'EINVERSTANDEN',
    optout: 'Abmeldung',
    settings: 'Privatsphäre-Einstellungen',
    message:
      'Du hast uns noch nichts über deine Datenschutzpräferenzen mitgeteilt! Das ist in Ordnung, aber wir möchten dir die beste Erfahrung mit dem Sales Companion bieten.',
    disabled:
      'Es scheint, als hättest du die Verwendung von Cookies deaktiviert.',
    use: 'Die {{AnwendungsName}} benötigt Cookies, um dir das beste Erlebnis zu bieten.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'Wie du deine Cookies aktivieren kannst, erfährst du {{hier}}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Du bist nicht eingeloggt',
    title: 'Du musst eingeloggt sein, um diesen Inhalt zu sehen',
    guest: 'Gast',
  },
  demo: {
    message:
      'Diese Website ist eine Demo des Endprodukts. Sie befindet sich derzeit in der Entwicklung und ist kein vollständiges Produkt.',
    consent: 'Ich habe verstanden!',
  },
  share: {
    header: 'Teile diese Ressource in deinen bevorzugten sozialen Medien!',
    download: 'download',
  },
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header:
      'Es sieht so aus, als würdest du versuchen, von einem mobilen Gerät aus auf die App {appName} zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuche einfach deinen App Store und suche nach {appName} oder klicke auf eine der folgenden Schaltflächen',
    benefits: {
      1: 'Unterwegs lernen, promoten und verkaufen',
      2: 'Multimediales Training über verschiedene Geräte hinweg',
      3: 'Abschlusszertifikat',
      4: 'Fertige Verkaufspräsentationen',
      5: 'Hochwirksame Werbematerialien',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Nachrichten und Updates',
      header: 'Damit erhältst du:',
    },
  },
  directoryView: {
    search: 'Suche...',
    amountOfResults: 'Anzahl der Ergebnisse:',
    filter: 'Filter',
    filters: 'Filter:',
    resetFilters: 'Filter zurücksetzen',
    showResults: 'Ergebnisse anzeigen',
    noResults:
      'Keine Ergebnisse gefunden. Bitte versuche es mit einer anderen Suche.',
    resetMap: 'Karte auf Start zurücksetzen >',
    viewNow: 'Jetzt ansehen >',
  },
  directory: {
    eat: 'essen',
    play: 'spielen',
    stay: 'bleiben',
    artsentertainment: 'Kunst & Unterhaltung',
    conventionservices: 'Dienstleistungen für Kongresse',
    divingsnorkeling: 'Tauchen & Schnorcheln',
    film: 'Film',
    hotels: 'Hotels',
    lgbtgymsandspas: 'LGBT+: Fitnessstudios und Spas',
    lgbtshopping: 'LGBT+: Shopping',
    lgbtwheretostay: 'LGBT+: Wo man übernachten kann',
    multiculturaldining: 'Multikulturell: Essen',
    multiculturalnightlife: 'Multikulturell: Nachtleben',
    nightlife: 'Nachtleben',
    petfriendly: 'Haustierfreundlich',
    restaurants: 'Restaurants',
    shopping: 'Einkaufen',
    spas: 'Spas',
    sports: 'Sport',
    transportation: 'Transport',
    venues: 'Veranstaltungsorte',
    waterways: 'Wasserstraßen',
    waystoplay: 'Spielmöglichkeiten',
    weddinglocations: 'Hochzeitslocations',
    weddingvendors: 'Hochzeits Vendors',
  },
  rewards: {
    rewards: 'Rewards',
    title: 'monaco Rewards',
    subTitle:
      'Wir geben dir die Chance, Rewards zu gewinnen, wenn du ein Spezialist in unserem Programm wirst und eine Reise nach Tampa Bay buchst!',
    body: 'Buche eine Reise nach Tampa Bay und du hast die Chance zu gewinnen! Gebe deine Buchungen ein, um eine EinführungsRewards von $5 US/CAN in Form einer E-Geschenkkarte zu erhalten.',
    item1:
      'Nach deiner ersten bestätigten Buchung von 4 Nächten oder mehr (für eine individuelle Reservierung) für mindestens zwei (2) Passagiere in einem qualifizierten Hotel/Resort. (Kreuzfahrten sind nicht anrechenbar.)',
    item2:
      'Das Angebot gilt, nachdem die wesentlichen Module des Tampa Bay-Programms abgeschlossen sind.',
    link1: 'Hast du Tampa Bay gebucht?',
    link2: 'Wenn ja, kannst du deine Buchung hier einreichen.',
    button: 'Buchung einreichen',
    bookingForm: {
      title: 'monaco Rewards',
      subTitle: 'Gib deine Buc hung ein:',
      required: '* Zeigt ein Pflichtfeld an',
      email: 'E-Mail des Mitarbeiters/der Mitarbeiterin',
      agentFirstName: 'Vorname des Mitarbeiters/der Mitarbeiterin',
      agentLastName: 'Nachname des Mitarbeiters/der Mitarbeiterin',
      company: 'Name des Unternehmens',
      iata: 'IATA/CLIA #',
      stateProvince: 'Staat/Provinz *',
      postalCode: 'Postleitzahl',
      country: 'Land',
      bookingNumber: 'Buchungsnummer',
      numberOfGuests: 'Anzahl der erwachsenen Gäste',
      bookingDate: 'Buchungsdatum',
      tourOperator: 'Reiseveranstalter',
      firstName: 'Vorname',
      lastName: 'Nachname',
      accommodation: 'Name der Unterkunft',
      wholesaler:
        'Name des Großhändlers (falls zutreffend): Wenn es sich um eine Direktbuchung handelt, gib KEINEN an.',
      arrivalDate: 'Ankunftsdatum',
      departureDate: 'Abreisedatum',
      reservationNumber: 'Reservierungsnummer',
      rooms: 'Anzahl der Zimmer',
      stay: 'Dauer des Aufenthalts (in Nächten)',
      airline: 'Fluggesellschaft/ Carrier (2-stelliger Code)',
      gateway: 'Abflug-Gateway (3-Buchstaben-Flughafencode)',
      destination: 'Zielort/Insel (Flughafencode mit 3 Buchstaben)',
      cost: 'Kosten (nur Dezimalzahlen verwenden)',
      disclaimer: '* Erforderliche Felder',
      button: 'Buchung einreichen',
      sub: 'Deine Informationen',
      sub2: 'Buchungsinformationen',
    },
    TermsAndConditions: {
      title: 'allgemeine Geschäftsbedingungen ',
      subTitle: 'Tampa Bay Specialist Quarterly Rewards',
      body1:
        'Jeder Buchung muss ein saldofreier Verkaufsbeleg beigefügt werden, der jeder einzelnen Buchung entspricht, die dugebucht hast. Die Preisträger werden auf der Grundlage der Gesamtheit der verifizierten Verkaufsnachweise ausgewählt, die jeder aufgeführten Buchung entsprechen. Buchungen müssen allen Tampa Bay Specialist Rewards-Regeln entsprechen, um teilnahmeberechtigt zu sein. Rewardsn sind nicht übertragbar und müssen innerhalb von drei (3) Monaten nach der Rewardsnbenachrichtigung eingelöst werden. Nicht genutzte, nicht in Anspruch genommene oder abgelehnte Rewardsn verfallen. Die Rewardsn werden vierteljährlich vergeben, und die Berechtigung wird anhand der durchgeführten Reisen überprüft.',
      body2:
        'Um teilnahmeberechtigt zu sein, musst du deinen Wohnsitz in den USA oder Kanada haben und in dem Staat, der Provinz oder dem Territorium, in dem du deinen Wohnsitz hast, volljährig oder älter sein. Mitarbeiter von Reiseveranstaltern sind NICHT teilnahmeberechtigt und werden NICHT für zusätzliche Preise berücksichtigt. Einwohner der Provinz Quebec sind NICHT teilnahmeberechtigt und werden NICHT für zusätzliche Preise berücksichtigt.',
      body3:
        'Für die Ausgabe der Rewards ist möglicherweise der Nachweis einer Akkreditierung als Reiseberater im Einzelhandel oder zu Hause erforderlich. Die verfügbaren Rewards können sich während der Laufzeit des Programms ändern.',
      body4: 'Datenschutz und Verwendung persönlicher Daten',
      body5:
        'Die teilnehmenden MitarbeiterInnen (i) gewähren dem Reward-Empfänger das Recht, seinen Namen, seine Stadt, sein Bundesland, seine Postleitzahl, seine Volljährigkeitsbestätigung, seine Telefonnummer und seine E-Mail-Adresse zu verwenden, unter anderem für die Kontaktaufnahme mit den Rewardsnempfängern und die Bekanntgabe der Rewardsnvergabe; (ii) räumt dem Preisträger das Recht ein, seine/ihre persönlichen Daten für Werbe- und Verkaufsförderungszwecke im Zusammenhang mit den Preisen in allen bekannten oder künftig entwickelten Medien ohne weitere Vergütung zu verwenden, es sei denn, dies ist gesetzlich verboten; und (iii) erkennt an, dass der Preisträger seine/ihre persönlichen Daten im Zusammenhang mit den unter (i) und (ii) genannten Aktivitäten an dritte Vertreter und Dienstleister weitergeben kann.',
      button: 'Zurück zur Hauptseite',
    },
    thankYouPage: {
      thanks: 'Dankeschön',
      congrats: 'Herzlichen Glückwunsch,',
      body: 'Deine Buchung ist eingegangen und zur Überprüfung an den Kampagnenbetreuer weitergeleitet worden.',
      link: 'Bitte beachte, dass du die wesentlichen Module des Tampa Bay Specialist Programs abgeschlossen haben musst, um zu den Gewinnern zu gehören',
    },
  },
  custom: {
    splitUsers: 'Ich bin ein ...',
    brandAmbassador: 'Brand Amabassador',
    travelPro: 'Travel Professional',
  },
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
};
